import { render, staticRenderFns } from "./new-arrivals-listing.vue?vue&type=template&id=04108a0a&scoped=true"
import script from "./new-arrivals-listing.vue?vue&type=script&lang=js"
export * from "./new-arrivals-listing.vue?vue&type=script&lang=js"
import style0 from "./new-arrivals-listing.vue?vue&type=style&index=0&id=04108a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04108a0a",
  null
  
)

export default component.exports